import PropTypes from "prop-types";
import clsx from "clsx";
import SectionTitleTwo from "../../components/section-title/SectionTitleTwo";
import teamMemberData from "../../data/team-members/team-member-one.json";
import TeamMemberMainSingle from "../../components/team-member/TeamMemberMainSingle";
import { useSelector } from "react-redux";
import useLang from "../../hooks/use-lang";
import { useMemo } from "react";

const TeamMemberMain = ({ spaceTopClass, spaceBottomClass }) => {
    const { our_achievements_award_images } = useSelector((state) => state.app);
    const LangUtils = useLang();

    const formattedData = useMemo(() => {
        return our_achievements_award_images.map((data) => ({
            id: data.id,
            title: LangUtils.getLangValue(data, "title"),
            subtitle: LangUtils.getLangValue(data, "subtitle"),
            description: LangUtils.getLangValue(data, "description"),
            button_text: LangUtils.getLangValue(data, "button_text"),
            external_url: data.external_url,
            image_url: data.section_image_1,
        }));
    }, [our_achievements_award_images, LangUtils]);
    console.log('our_achievements_award_images', our_achievements_award_images)
    return (
        <div className={clsx("team-area", spaceTopClass, spaceBottomClass)}>
            <div className="container">
                <div className="row">
                    {formattedData?.map((single, key) => (
                        <div className="col-lg-3 col-md-6 col-sm-6" key={key}>
                            <TeamMemberMainSingle
                                data={single}
                                spaceBottomClass="mb-30"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

TeamMemberMain.propTypes = {
    spaceBottomClass: PropTypes.string,
    spaceTopClass: PropTypes.string,
};

export default TeamMemberMain;
